import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';
import { defineEntitySource } from '@/shared/form/entity-source';
import { getCurrentTenant } from '@/shared/http/client';

// Filtros da lista declarados uma vez (P01): o `FilterProvider` de `CommunicationSettingContainer.tsx:125-146`
// e o formulário de `components/DataTableFilters/CommunicationSettingFilters/*`. Arquivo leve: a rota usa
// o `shape` no `validateSearch` (JS inicial), então a busca de carteira entra por import dinâmico.

export interface WalletItem {
  readonly walletCode: number;
  readonly beneficiaryName?: string | null | undefined;
}

/**
 * Convênio (`GET /Wallet`, porta F0-min de `wallet`): valor = `walletCode`, rótulo
 * `({walletCode}) - {beneficiaryName}` como o autocomplete do legado (`walletContext.tsx:99-102`).
 */
export const walletCodeSource = defineEntitySource<WalletItem>({
  key: ['communication-setting', 'wallet'],
  scope: () => getCurrentTenant() ?? null,
  search: async (query, signal) => {
    const { listWalletOptions } = await import('@/modules/wallet/public');
    const page = await listWalletOptions({ search: query || undefined, tenant: getCurrentTenant() }, signal);
    return page.data;
  },
  toOption: (item) => ({ value: String(item.walletCode), label: `(${String(item.walletCode)}) - ${item.beneficiaryName ?? ''}` }),
});

export const communicationSettingFilters = defineFilters([
  // `multiple: true` no legado: a chave repete no fio (`walletsCode=1&walletsCode=2`).
  { key: 'walletsCode', type: 'entity', label: msg`Código do convênio`, placeholder: msg`Buscar convênio`, source: walletCodeSource, multiple: true, pinned: true },
  { key: 'name', type: 'text', label: msg`Nome` },
  { key: 'walletNumber', type: 'text', label: msg`Número da carteira`, max: 20 },
  { key: 'daysToSendBillingBeforeDueDate', type: 'text', label: msg`Dias para envio`, max: 3 },
]);
